<template>
  <div
    class="md:pb-8 h-1/2" 
    v-if="tenantInfo !== null && tenantInfo.tenant !== undefined"
  >
    <div>
      <span
        class="flex justify-center items-center m-5"
        v-if="!onlyOneSport()"
      >
        <div class="flex">
          <SportSelector
          v-model="activeSport"
          :sports="this.tenantInfo.tenant.sports"
          :showLabels="false"
          :titleTop="false"
          @sportSelected="setActiveSport"
        />
        </div>
      </span>
      <div>
        <div class="flex flex-wrap items-center justify-center m-auto overflow-y-auto mt-4">
          <MatchAvailability
            :matches="matches || []"
            :showButton="false"
            :activeSport="activeSport"
            @matchSelected="matchSelected"
            @createMatch="createMatch"
            ref="matchAvailability" 
          />
        </div>
      </div>
      <div>
        <MatchSuggestions 
          :filteredDataToSend="dataToSend"
          :showTittle="true"
          :allowShowMore="false"
          @hourSelected="handleHourSelected"
          @showErrorMessage="handleShowErrorMessage"
        />
      </div>
      <div v-if="errorMsg && showMessage" class="flex justify-center items-center mt-3 md:p-4 br16 error-message text-center w-full">
        <h5>{{ $t("search_no_resources_found") }}</h5>
      </div>
    </div>
    <Transition>
      <PopUpLight
        v-if="showGenderLevel && !isLoading"
        @closed="closeGenderLevel()"
        :customClass="'width-sm'"
        :showClose="false"
      >
        <UpdateUser
          :customSport="activeSport"
          @closeGenderLevel="closeGenderLevel()"
        />
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showHasGender"
        :showClose="false"
      >
        <div class="mt-8">
          <UserGenderSelector @selectionChanged="saveGenderChanges" />
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showIframe" 
        @closed="showIframe= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          <iframe class="iframe" title="redPadel login" frameborder="0" :src="iframeSrc"></iframe>
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showRedpadelError" 
        @closed="showRedpadelError= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          {{ $t("oops_technical_problems_try_again_in_a_few_minutes") }}
        </div>
      </PopUpLight>
    </Transition>
  </div>
</template>
  
<script type="ts">
import { Category, Sport, GlobalErrors, LevelProvider } from "@/enum/constants";
import { setTimeToDate, formatDate, beautifyDate, beautifyDateWithOutTime, } from "@/helpers/dateHelper";
import { checkURLBookingFormat } from "@/helpers/dataHelper";
import { SearchType } from "@/enum/constants";
import MatchAvailability from "@/components/search/matchAvailability.vue";
import { AppsHelper } from "@/helpers/appsHelper";
import { Format } from "@/helpers/formatHelper";
import store from '@/store';
import { BookingHelper } from "@/helpers/bookingHelper";
import PopUpLight from "@/components/popup/popupLight.vue";
import UserGenderSelector from "@/components/form/userGenderSelector.vue";
import SportSelector from "@/components/form/sportSelector.vue";
import CustomerHelper from "@/helpers/customerHelper";
import MatchSuggestions from "@/components/match/matchSuggestions.vue"
import UpdateUser from "@/components/match/updateUser.vue";
import MatchHelper from "@/helpers/matchtHelper";

export default {
  name: "bookMatches",
  props: ["tenantInfo"],
  emits: ["privateClub"],
  components: {
    MatchAvailability,
    UserGenderSelector,
    PopUpLight,
    SportSelector,
    MatchSuggestions,
    UpdateUser
  },
  data() {
    return {
      hours: [],
      dateStr: "",
      showCalendar: false,
      sport: Sport, // to use in html
      activeHour: "",
      activeSport: Sport.PADEL,
      tenantId: null,
      activeDate: new Date(),
      matches: [],
      category: Category,
      hasGender: true,
      isUserLogged: false,
      level: null,
      errorMsg: null,
      appHeightListener: null,
      dataToSend: {},
      showMessage: true,
      canCreateMatch: false,
      showIframe: false,
      showRedpadelError: false,
      showHasGender: false,
      iframeSrc:"",
      showGenderLevel: false,
      levelProvider: LevelProvider.PANDORA,
      hourSelectedData: null
    };
  },
  async created() {
    if (!checkURLBookingFormat) {
      return;
    }
    this.activeSport = +this.$route.query.sport;
    this.isUserLogged = CustomerHelper.isUserLogged();
    this.tenantId = this.$route.query.id;
    this.activeHour = this.$route.query.hour;
    if (this.activeHour === undefined) {
      this.activeHour = "0";
    }

    this.activeDate = setTimeToDate(new Date(this.$route.query.date), this.activeHour);
    this.dateStr = beautifyDate(this.activeDate, true, false);

    this.dataToSend = {
      tenantIds: [this.$route.query.id],
      name: this.$route.query.name,
      date: this.$route.query.date,
      sport: this.activeSport,
      category: Category.BOOKING,
      radius: 3,
      searchType: SearchType.FULL,
      flexibleTime: true,
    };

    store.commit("setLoading", true);
    await this.loadMatches();
    store.commit("setLoading", false);
  },
  async mounted(){
    this.fixIphoneHeight();
  },
  methods: {
    async initGenderLevel() {
      this.hasGender = await CustomerHelper.hasGender();
      if(!this.hasGender && this.levelProvider == LevelProvider.REDPADEL){
        this.showHasGender = true;
        return false;
      }
      this.isLoading = true;
      const hasLevel = await CustomerHelper.hasLevel(this.activeSport, this.levelProvider);
      this.isLoading = false;
      if(hasLevel) {
        return true;
      }
      this.levelProvider === LevelProvider.PANDORA ? this.showGenderLevel = true : await this.initRedPadelLevel();
      return false;
    },
    async linkRedPadelAccount(linkLevelProvider){
      try {
        await CustomerHelper.linkLevelProviderAccount(linkLevelProvider, LevelProvider.REDPADEL);
        this.sendMatch();
      } catch (error) {
        this.showRedpadelError = true;
      }
    },
    async redPadelListener(event) {
      window.removeEventListener("message", this.redPadelListener);
      const resultData = event.data;
      this.showIframe = false;
      if(resultData.status){
        const linkLevelProvider = {
          accountId: resultData.user_id,
        };
        await this.linkRedPadelAccount(linkLevelProvider);
      }else{
        this.showRedpadelError = true;
      }
    },
    async initRedPadelLevel(){
      this.showHasGender = false;
      if(this.hasGender){
        const response = await CustomerHelper.getProviderRedirectURL(LevelProvider.REDPADEL);
        if(response){
          this.iframeSrc = response.redirectURL;
          this.showIframe = true;
          window.addEventListener("message", this.redPadelListener);
        }
      }
    },
    async closeGenderLevel() {
       this.showGenderLevel = false;
       this.canCreateMatch = true;
       this.sendMatch();
    },
    handleShowErrorMessage(showMessage){
      this.showMessage = showMessage
    },
    async handleHourSelected(data){
      this.hourSelectedData = data
      this.levelProvider = MatchHelper.getLevelProviderBySport(data.defaultLevelProviders, this.activeSport);
      this.canCreateMatch = await this.initGenderLevel();
      if(!this.canCreateMatch){
        return;
      }
      this.sendMatch()
    },
    sendMatch(){
      const createMatchQuery = {
        name: "createMatch",
        query: {
          id: this.hourSelectedData.tenantId,
          name: this.hourSelectedData.name,
          hour: this.hourSelectedData.hour,
          date: this.$route.query.date,
          sport: this.activeSport,
          category: this.category.MATCH,
          radius: 3,
          searchType: SearchType.FULL,
          levelProvider: this.levelProvider,
          showDateSelector: true
        },
      };
      return this.$router.push(createMatchQuery);
    },
    async saveGenderChanges(gender) {
      const user = await CustomerHelper.updateGender(gender);
      if (user) {
        CustomerHelper.updateStorageUser(user);
        this.hasGender = true;
        this.initRedPadelLevel();
      }
      this.showHasGender = false;
    },
    matchSelected(match) {
      let url = "/booking-join/" + match.id;
      if (match.side !== undefined) {
        url += "?s=" + match.side;
      }
      if (match.team !== undefined) {
        url += "&t=" + match.team;
      }
      this.$router.push(url);
    },
    createMatch() {
      var request = {
        name: "search-results",
        query: {
          tenantIds: this.tenantId,
          date: this.$route.query.date,
          sport: this.activeSport,
          category: this.category.BOOKING,
          hour: this.activeHour,
          radius: 3,
          searchType: SearchType.FULL,
          createMatchMode: true,
        },
      };
      return this.$router.push(request);
    },
    async loadMatches() {
      this.errorMsg = null;
      this.matches = null;
      if(!this.hasGender){
        return;
      }
      const request = {
        tenantIds: [this.$route.query.id],
        date: this.getDateSystemFormat(),
        sport: this.activeSport,
        category: Category.MATCH,
        searchType: SearchType.FULL,
      };
      try {
        store.commit("setLoading", true);
        const message = await BookingHelper.messageAvailability(request);
        store.commit("setLoading", false);
        if (Format.IsNull(message.matches) || message.matches.length === 0) {
          this.errorMsg = this.$t("there_are_no_matches_for_the_selected_date_go_ahead_and_create_one");
          return;
        }
        this.matches = message.matches.sort((a, b) => new Date(a.date) - new Date(b.date));
      } catch (error) {
        if (error.response.status === GlobalErrors.ERROR_PRIVATE_CLUB) {
          this.$emit("privateClub");
        }
        return;
      } finally{
        store.commit("setLoading", false);
      }
    },
    async parentCallGetAvailability(date){
      this.isUserLogged = CustomerHelper.isUserLogged();
      const currentQuery = { ...this.$route.query };
      currentQuery.date = formatDate(date);
      this.$router.replace({ query: currentQuery });
      this.activeDate = date;
      this.dateStr = beautifyDateWithOutTime(this.activeDate, true, false);
      this.dataToSend = {
        tenantIds: [currentQuery.id],
        name: currentQuery.name,
        date: currentQuery.date,
        sport: currentQuery.sport,
        category: Category.BOOKING,
        radius: 3,
        searchType: SearchType.FULL,
        flexibleTime: true,
      };
      await this.loadMatches();
    },
    async setActiveSport(sport) {
      this.activeSport = +sport;
      this.activeHour = "";
      await this.loadMatches();
    },
    onlyOneSport() {
      return this.tenantInfo.tenant.sports.length === 1;
    },
    getDateSystemFormat() {
      return formatDate(this.activeDate);
    },
    fixIphoneHeight() {
      if (AppsHelper.isIOS()) {
        const resultsContainer = document.querySelector("#ResultsContainer");
        if (resultsContainer) {
          resultsContainer.classList.add('pb-100');
          const newMatchBtn = document.querySelector(".createMatch");
          newMatchBtn.classList.add('iOS-bottom-btn');
        }
      }
    }
  },
};
</script>
<style scoped>
.createMatch {
  background: linear-gradient(90deg, var(--color1) 35%, var(--color2) 100%);
  text-align: center;
  min-width: 200px;
}
</style>